// DEPENDENCIES
import React, { useEffect, useRef } from 'react';
// COMPONENTS
// ICONS
import { HiChevronRight } from 'react-icons/hi';
import { BiSearchAlt2 } from 'react-icons/bi';
// CUSTOM COMPONENTS
import CustomBlock from '../../../components/CustomBlock';
import ContentHeader from '../../../components/ContentHeader';
import constants from '../../../../constants/constants';
//SERVICES AND HELPERS
import * as dashboardService from '../../../../services/dashboard/dashboardService';

var L = window.L;
L.mapquest.key = constants.MAPQUEST_KEY;

const JobLocationsAndMapsBlock = (props) => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    dashboardService.getLatestLoginLocation().then((res) => {
      createMap(res);
    });

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!mapContainerRef.current || !window.ResizeObserver) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      if (mapRef.current) {
        mapRef.current.invalidateSize();
      }
    });

    resizeObserver.observe(mapContainerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const createMap = (sessions) => {
    if (!mapContainerRef.current || mapRef.current) {
      return;
    }

    mapRef.current = L.mapquest.map(mapContainerRef.current, {
      center: [30.3886803239576, -91.04900000150919],
      layers: L.mapquest.tileLayer('map'),
      zoom: 10,
    });

    sessions.forEach((x) => {
      L.marker([x.latitude, x.longitude])
        .addTo(mapRef.current)
        .bindPopup(x.fullName + ' ' + x.dateLoggedIn);
    });

    setTimeout(() => {
      if (mapRef.current) {
        mapRef.current.invalidateSize();
      }
    }, 100);
  };

  return (
    <>
      <CustomBlock className='content-container--card-style large-card aes-dashboard-map-card p-0 overflow-hidden h-100'>
        <CustomBlock className='header-block'>
          <CustomBlock>
            {/* <ContentHeader
                            subtitle="Location and Map"
                            headerSize="sm"
                            textHeaderStyle="pb-0"
                        /> */}
          </CustomBlock>
        </CustomBlock>
        {/* <div className="row" id="map" style={{ height: '34vh' }}></div> */}
        <div ref={mapContainerRef} className='aes-dashboard-map' style={{ height: '100%', zIndex: '0' }}></div>
      </CustomBlock>
    </>
  );
};

export default JobLocationsAndMapsBlock;
